import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  SafeAreaView,
  TouchableOpacity,
  Image,
  ScrollView,
} from 'react-native';
import { ms, s, vs } from '../../../../utils/responsive';
import { useNavigation } from '@react-navigation/native';
import { RootStackNavigationProp } from '../../../../types/navigation';
import { BottomNavBar } from '../../../../components/BottomNavBar';
import { tasksService } from '../../../../services/tasks';
import { mapTaskIdToKey } from '../../../../utils/taskKey';

import { createLogger } from '../../../../utils/logger';
const logger = createLogger('InvestmentAdvisorInfoIntro');

export const InvestmentAdvisorInfoIntroScreen: React.FC = () => {
  const navigation = useNavigation<RootStackNavigationProp>();

  const handleYes = () => {
    navigation.navigate('InvestmentAdvisorInfoInput');
  };

  const handleNo = async () => {
    try {
      const taskKey = mapTaskIdToKey(48); // Investment Advisor task
      await tasksService.completeTask(taskKey);
      // Mark decline flag so safeguards keep it completed without data
      const AsyncStorage = require('@react-native-async-storage/async-storage').default;
      await AsyncStorage.setItem('task_declined_48', 'true');
    } catch (e) {
      // Non-blocking; still return to checklist
      logger.debug('Error completing investment advisor task on decline:', e);
    }
    // Navigate explicitly to the Finance stack's checklist to trigger focus/refresh
    (navigation as any).navigate('Finance', { screen: 'FinanceChecklist', params: { refreshKey: Date.now() } });
  };

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.mainContent}>
        <View style={styles.header}>
          <TouchableOpacity 
            style={styles.backButton}
            onPress={() => navigation.goBack()}
          >
            <Image
              source={require('../../../../assets/icons/back.png')}
              style={styles.backIcon}
            />
          </TouchableOpacity>
          <Image
            source={require('../../../../assets/logo.png')}
            style={styles.logo}
            resizeMode="contain"
          />
        </View>

        <ScrollView contentContainerStyle={styles.content}>
          <Text style={styles.title}>Do you currently have an Investment Advisor?</Text>
          
          <View style={styles.buttonContainer}>
            <TouchableOpacity
              style={[styles.button, styles.yesButton]}
              onPress={handleYes}
            >
              <Text style={[styles.buttonText, styles.yesText]}>Yes</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={[styles.button, styles.noButton]}
              onPress={handleNo}
            >
              <Text style={[styles.buttonText, styles.noText]}>No</Text>
            </TouchableOpacity>
          </View>

          <Text style={styles.description}>
            Be sure to share your Investment Advisor’s contact information so your loved ones can reach them if needed. If they also manage business matters, you can include that in a separate section.
          </Text>
        </ScrollView>
      </View>
      <BottomNavBar />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  mainContent: {
    flex: 1,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: ms(50),
    position: 'relative',
  },
  backButton: {
    position: 'absolute',
    left: ms(50),
    top: ms(15),
    padding: ms(5),
    zIndex: 1,
  },
  backIcon: {
    width: ms(32, 0.3),
    height: ms(32, 0.3),
    tintColor: '#333',
  },
  logo: {
    width: ms(125, 0.3),
    height: ms(125, 0.3),
  },
  content: {
    flexGrow: 1,
    padding: ms(20),
    alignItems: 'center',
  },
  title: {
    fontSize: ms(28, 0.3),
    fontWeight: '600',
    color: '#2C4364',
    marginBottom: ms(30),
    textAlign: 'center',
    paddingHorizontal: ms(20),
  },
  description: {
    fontSize: ms(18, 0.3),
    color: '#666666',
    textAlign: 'center',
    marginTop: ms(30),
    paddingHorizontal: ms(20),
    lineHeight: ms(25, 0.3),
  },
  buttonContainer: {
    width: '100%',
    paddingHorizontal: ms(20),
  },
  button: {
    width: '100%',
    borderRadius: ms(30),
    padding: ms(15),
    alignItems: 'center',
    marginBottom: ms(15),
  },
  yesButton: {
    backgroundColor: '#29BFC0',
  },
  noButton: {
    backgroundColor: '#FF9F64',
  },
  buttonText: {
    fontSize: ms(16, 0.3),
    fontWeight: '500',
  },
  yesText: {
    color: '#FFFFFF',
  },
  noText: {
    color: '#FFFFFF',
  },
}); 